import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import somethingwentwrong from "../../../img/somethingwentwrong.png"
import { useParams ,useHistory, useRouteMatch,} from "react-router-dom";

import { useSelector } from "react-redux";
import {X,Plus ,Star,BookmarkPlus} from 'lucide-react';

import SnackbarSidebar from "../../../../SnackbarSidebar";
import { getAllCourseThumbnails } from "../../../../store/actions/CreateCourse/getAllCourseThumbnails";


const AddThumbnailSubCourse = ({sendBackImage,Thumbnail})=>{
  const {courseId} = useParams();
//   const {url}=useRouteMatch();
  const history = useHistory();
 const dispatch = useDispatch();  
 const [snackbarVisible, setSnackbarVisible] = useState(false);
 
 const [snackbarColor, setSnackbarColor] = useState("#958FDA");
 const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
 const showSnackbar = () => {
  setSnackbarVisible(true);
};

 const hideSnackbar = () => {
  setSnackbarVisible(false);
};
const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
  {
    
    dispatch({type: "CURSOR",payload:true  });

    dispatch({type: "CURSORTEXT",payload:CursorText})
    dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
    dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
  }
   
  const handleMouseLeave = () => {
    
    dispatch({type: "CURSOR",payload:false})

    dispatch({type: "CURSORTEXT",payload:""})

    dispatch({type: "CURSORTEXTBG",payload:""})
    dispatch({type: "CURSORTEXTCOLOR",payload:""})
  

}
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
 const user_email = useSelector((state)=>state?.user?.user?.user_email
);

const postIdCourse = useSelector((state)=>state?.course?.course?.postId);

const courseData = useSelector((state)=>state?.course?.course);

      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);

 const [loader , setLoader] =useState({status:false});
 
const [openPopUp ,setOpenPopUp]  = useState(true)
 const [imagesJson, setImagesJson] = useState([])
 
 const [animate, setAnimate] = useState(false); 
 const [animateTwo, setAnimateTwo] = useState(false);
 const [selectedImg , setSelectedImg] =useState(Thumbnail)
 const [selectedImgPopUp , setSelectedImgPopUp] =useState(false)
 const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);

 useEffect(() => {
    clickAllCategories()
 }, []);

 





const clickAllCategories=(e)=>{

  setAnimateTwo(false); 

setLoader({status:true});
const resp = dispatch(getAllCourseThumbnails({}));
  /* get response as Promise   */
  resp.then(response => {

    // console.log(response)
    setImagesJson(response)
    setOpenPopUp(true);
/* resetting Login input Fields */

setLoader({status:false});

const timerTwo = setTimeout(() => {
  setAnimateTwo(true);  
}, 100);

 return () => clearTimeout(timerTwo); 


  }).catch(error => {
 
    //popup of error Info
 
setLoader({status:false});
    // console.error(error);
  });
 
  }


  const handleSubCourseThumbnail=(image)=>{
sendBackImage(image?.thumbnail);
      }
    
    return <>
    
{<>

{snackbarVisible && (
        <SnackbarSidebar message={responseMessage} color={snackbarColor}  onClose={hideSnackbar} />
      )}
<div  className="">
  
  <img  onClick={()=>{ clickAllCategories()}}  className="" src={Thumbnail} 
          alt="selected Img"
     style={{cursor:"pointer",width:"300px",
      
     }}/>  

  {openPopUp?<div className="selectThumbImgOuterAll"  style={{zIndex:99999}}>
   
  
   <div  className="selectThumbImgOuter" style={{zIndex:999999}}>
   <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"40px",height:"40px",cursor:"pointer",
        borderRadius:"50%",float:"right",margin:"10px",
      background:"#958FDA",zIndex:999999}} onClick={()=>setOpenPopUp(false)}   >
        <X  style={{padding:"9px",}} color="#fff" size={22}/></div> 
<div  className="selectThumbImgOuterContainer" style={{} }>
    {imagesJson!=[]&&imagesJson!=undefined?Object.values(imagesJson).map((item,index)=>
    <div onClick={(e)=>{handleSubCourseThumbnail(item);setOpenPopUp(false)}} className="selectThumbImgDiv"><img  className="selectThumbImg" index={index} key={item.term_id} src={item.thumbnail} alt={item.name}
    style={{cursor:"pointer",
      transform: animateTwo ? 'scale(1)' : 'scale(0)',
      opacity: animateTwo ? 1 : 0,

      transition: `transform ${index<4?index+1:index-2}s ease, opacity ${index<4?index+1:index-2}s ease`,
    }}/></div>
   ): <div align="center"><img  className="selectThumbImg" src={somethingwentwrong} alt="something went wrong"
   style={{cursor:"pointer",width:"300px",
    
   }}/> <h1 style={{"textAlign":"center",
       
      }}>  Something Went <span className="coloredTextV1">Wrong !!!!!!!!!!!!</span> </h1></div>}
   
   </div>
   </div>
   
   </div>:""}
  
  
  
  </div>
</>}
    </>

}
export default AddThumbnailSubCourse;